import { Box, Flex, Paper, Text } from "@mantine/core"
import { useTranslation } from "react-i18next"
import { TopProduct } from "../hooks"
import { CardHeader } from "./CardHeader"
import classes from "../real.module.css"

interface Props {
  products: TopProduct[]
}

export function TopProductsCard({ products }: Props) {
  const { t } = useTranslation(["dashboard", "common"])
  const maxCount = Math.max(...products.map((p) => p.count), 1)

  return (
    <Paper className={classes.card}>
      <CardHeader
        title={t("dashboard:widgets.topProducts")}
        subtitle={`${t("dashboard:widgets.topProductsSub", { defaultValue: "Хамгийн их захиалагдсан" })} · ${t("dashboard:selectedMonth")}`}
      />

      {products.length === 0 ? (
        <Text fz={14} c="dimmed" ta="center" py="md">
          -
        </Text>
      ) : (
        <Box>
          {products.map((item, index) => {
            const barWidth = Math.max((item.count / maxCount) * 100, 6)
            const isTop3 = index < 3
            return (
              <Flex key={index} align="center" gap={10} className={classes.productItem}>
                <Box className={classes.productRank} data-top={isTop3 || undefined}>{index + 1}</Box>
                <Box style={{ flex: 1, minWidth: 0 }}>
                  <Text className={classes.productName} lineClamp={1}>{item.name}</Text>
                  <Box className={classes.productBar}>
                    <Box className={classes.productBarFill} style={{ width: `${barWidth}%` }} />
                  </Box>
                </Box>
                <Text className={classes.productCount}>{item.count} {t("dashboard:numberFormat.unit")}</Text>
              </Flex>
            )
          })}
        </Box>
      )}
    </Paper>
  )
}
